import { render, staticRenderFns } from "./Saee10History.vue?vue&type=template&id=0e22dd7a"
import script from "./Saee10History.vue?vue&type=script&lang=js"
export * from "./Saee10History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports